import React from 'react'
import { Message } from 'semantic-ui-react'

import { RetryChargeButton as DefaultRetryChargeButton } from 'organisms/RetryChargeButton'
import { getReasonFailedMessage } from './utils'

/**
 *
 * @typedef {object} Invoice
 * @property {string} id
 * @property {string} amount_due
 * @property {import('./utils').Charge} latest_charge
 *
 * @param {object} props
 * @param {boolean} props.isActiveSubscription
 * @param {Invoice=} props.latestInvoice
 * @param {React.FunctionComponent} [props.RetryChargeButton]
 */
function FailedMessage({
  isActiveSubscription,
  latestInvoice,
  RetryChargeButton = DefaultRetryChargeButton,
}) {
  if (isActiveSubscription || !latestInvoice) {
    return null
  }

  const reason = getReasonFailedMessage(latestInvoice.latest_charge)
  return (
    <Message size="small" className="!bg-blue-lighter">
      <Message.Header>Your latest credit card payment failed</Message.Header>
      <p>Reason: {reason}</p>
      <p>
        To resolve this, please try adding a different card or contacting your bank. When you're
        ready, you can retry the charge.
      </p>

      <RetryChargeButton invoiceId={latestInvoice.id} price={latestInvoice.amount_due} />
    </Message>
  )
}

export default FailedMessage



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Billing/FailedMessage.js